import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/api/auth';
import { useAuthStore } from './auth-store';

export function useLogin() {
  const setUser = useAuthStore((s) => s.setUser);
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: (user) => setUser(user),
  });
}

export function useLogout() {
  const reset = useAuthStore((s) => s.reset);
  return useMutation({
    mutationFn: authApi.logout,
    onSettled: () => reset(),
  });
}
